module.exports = {"importing":"Prebieha importing subjektov do skupiny "}